import { c as _c } from "react/compiler-runtime";
enum PromptLibraryLink {
  BI = 'https://www.notion.so/newfront/21d63cbd78f8806c9d03c01472100829?v=21d63cbd78f880829db6000c11062491',
  TR = 'https://www.notion.so/newfront/21d63cbd78f8809bbeb2c62a5e0d3436?v=21d63cbd78f8802486bd000cc7b14182',
}

/**
 * Disclaimer component that displays Nova Assist disclaimer with prompt library links.
 */
export function ChatDisclaimer() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <a href={PromptLibraryLink.BI} target="_blank" rel="noreferrer" className="font-semibold underline">BI</a>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="text-muted-foreground block py-3 text-center text-sm">Nova Assist can make mistakes. Explore what Nova can do: Browse prompt library for{" "}{t0}{" "}and{" "}<a href={PromptLibraryLink.TR} target="_blank" rel="noreferrer" className="font-semibold underline">TR</a></span>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}